<template>
  <section>
    <b-modal :active.sync="active">
      <div class="container">
        <b-datepicker
          locale="ja-JP"
          style="width: 100%; text-align: center;"
          ref="datepicker"
          v-model="changeDate"
          size="is-small"
          icon="calendar-today"
          :years-range="[-100, 100]"
          inline>"
        </b-datepicker>
        <button class="button is-small is-primary" style="margin-top: 8px; width: 298px;" @click="emitted()">変更</button>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'

export default {
  name: 'ModalEditDate',
  components:{
  },
  mixins: [
    controlLogMixin
  ],
  data () {
    return {
      active: false,
      changeDate: null,
      sk: null
    }
  },
  computed: {
    ...mapState('mediapool', ['images', 'videos', 'editModalActive', 'editModalTarget', 'archiveFlag'])
  },
  methods: {
    emitted () {
      this.sendControlLog('応募者生年月日選択', '応募者管理画面にて、応募者の生年月日を選択した。')
      this.$nextTick(() => {this.$emit('saveDate', {date: this.changeDate, sk: this.sk})})
      this.active=false
    },
    toggle () {
      this.active = true
    }
  }
}
</script>

<style lang='scss' scoped>
.container {
  text-align: center;
}

.modal-media {
  height: 300px;
  width: 100%;
  object-fit: cover;
}

.title {
  font-size: 22px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}

.card-header-title {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

</style>



// WEBPACK FOOTER //
// src/components/ui/ModalEditDate.vue